import types from '../../../../actionTypes'

export const CARD = types('CARD')
export const CLEAR_CARD_ERROR = types('CLEAR_CARD_ERROR')
